import { OmnibarEntry } from '../omnibar-interfaces';
import { getMostSelectedIds } from './top-entries';

const recentStorageKey = 'recentOmnibarSelections';
const favoritesGroup = 'Favoritter';
const recentGroup = 'Senest brugt';
const mostUsedGroup = 'Oftest brugt';
const recentLimit = 3;
const mostUsedLimit = 5;
const storedRecentLimit = 10;

function getRecentIds(): string[] {
  try {
    const stored = JSON.parse(localStorage.getItem(recentStorageKey) || '[]');
    return Array.isArray(stored) ? stored : [];
  } catch {
    return [];
  }
}

export function recordRecentSelection(entry: OmnibarEntry) {
  const recentIds = [entry.id, ...getRecentIds().filter(id => id !== entry.id)].slice(0, storedRecentLimit);
  localStorage.setItem(recentStorageKey, JSON.stringify(recentIds));
}

function pickByIds(ids: string[], available: OmnibarEntry[], taken: Set<OmnibarEntry>, limit: number) {
  return ids
    .map(id => available.find(entry => entry.id === id && !taken.has(entry)))
    .filter((entry): entry is OmnibarEntry => entry !== undefined)
    .slice(0, limit);
}

// MUI's groupBy needs options from the same group to be adjacent; groups keep the order they first appear in.
function groupAdjacent(entries: OmnibarEntry[]) {
  const groupOrder = new Map<string, number>();
  entries.forEach(entry => {
    const group = entry.group ?? '';
    if (!groupOrder.has(group)) groupOrder.set(group, groupOrder.size);
  });
  return [...entries].sort((a, b) => (groupOrder.get(a.group ?? '') ?? 0) - (groupOrder.get(b.group ?? '') ?? 0));
}

export function composeStartEntries(available: OmnibarEntry[], recentIds = getRecentIds(), mostUsedIds = getMostSelectedIds(), favoriteIds: string[] = []) {
  const taken = new Set<OmnibarEntry>();
  const favorites = pickByIds(favoriteIds, available, taken, favoriteIds.length);
  favorites.forEach(entry => taken.add(entry));
  const recent = pickByIds(recentIds, available, taken, recentLimit);
  recent.forEach(entry => taken.add(entry));
  const mostUsed = pickByIds(mostUsedIds, available, taken, mostUsedLimit);
  mostUsed.forEach(entry => taken.add(entry));

  return [
    ...favorites.map(entry => ({ ...entry, group: favoritesGroup })),
    ...recent.map(entry => ({ ...entry, group: recentGroup })),
    ...mostUsed.map(entry => ({ ...entry, group: mostUsedGroup })),
    ...groupAdjacent(available.filter(entry => !taken.has(entry))),
  ];
}
